export default __webpack_public_path__ + "static/media/0x6A555cB5Aa145C203875dc9c15fF0e61610DB74F.7470629d.png";